<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Warehouse_Imports_Title' | translateWF: 'Warehouse Imports' }}</h1>
      </div>
    </div>

    <p-panel>
      <p-card data-variant="compact">
        <p-tabs value="0">
          <p-tablist>
            <p-tab value="0">
              {{ 'Warehouse_Imports_Incoming_Shipments' | translateWF: 'Incoming Shipments' }}
            </p-tab>
            <p-tab value="1">
              {{ 'Warehouse_Imports_Past_Shipments' | translateWF: 'Past Shipments' }}
            </p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0" id="0">
              <div class="cls-page-list-grid">
                <p-table [value]="getIncomingShipments()" selectionMode="single">
                  <ng-template #header>
                    <tr>
                      <th>{{ 'Warehouse_Imports_Shipment_ID' | translateWF: 'Shipment ID' }}</th>
                      <th>{{ 'Warehouse_Imports_Status' | translateWF: 'Status' }}</th>
                      <th>{{ 'Warehouse_Imports_Estimated_Arrival' | translateWF: 'Estimated Arrival' }}</th>
                      <th>{{ 'Warehouse_Imports_Arrival_Date' | translateWF: 'Arrival Date' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-shipment>
                    <tr class="cursor-pointer" (click)="redirectToDetails(shipment.id)">
                      <td>
                        <a>{{ shipment.shipmentNumber }}</a>
                      </td>
                      <td>{{ statusFormatted(status[shipment.status]) }}</td>
                      <td>
                        {{ getFormatedDate(shipment.estimatedArrivalDate) }}
                      </td>
                      <td>{{ getFormatedDate(shipment.actualArrivalDate) }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabpanel>
            <p-tabpanel value="1" id="1">
              <div class="cls-page-list-grid">
                <p-table [value]="getCompletedShipments()" selectionMode="single">
                  <ng-template #header>
                    <tr>
                      <th>{{ 'Warehouse_Imports_Shipment_ID' | translateWF: 'Shipment ID' }}</th>
                      <th>{{ 'Warehouse_Imports_Status' | translateWF: 'Status' }}</th>
                      <th>{{ 'Warehouse_Imports_Estimated_Arrival' | translateWF: 'Estimated Arrival' }}</th>
                      <th>{{ 'Warehouse_Imports_Arrival_Date' | translateWF: 'Arrival Date' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-shipment>
                    <tr class="cursor-pointer" (click)="redirectToDetails(shipment.id)">
                      <td>
                        <a>{{ shipment.shipmentNumber }}</a>
                      </td>
                      <td>{{ statusFormatted(status[shipment.status]) }}</td>
                      <td>
                        {{ getFormatedDate(shipment.estimatedArrivalDate) }}
                      </td>
                      <td>{{ getFormatedDate(shipment.actualArrivalDate) }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </p-card>
    </p-panel>
  </div>
</main>
